import pdfMake from 'pdfmake/build/pdfmake'
import JsBarcode from 'jsbarcode'
import { logo2Img } from '../../../../services/others/assets'

/**
 * Packing Slip PDF Generator - Without Price
 * 不含价格版本
 */
export default async (data: any, require?: string, getBlob?: any, filename?: string) => {
  const orderNo = data.packingSlipNo
  const deliveredAt = data.deliveredAt
  const deliveryName = data.customer.deliveryName
  const outstanding = data.outstanding
  const comments = !data.customer.warehouseNote ? '' : data.customer.warehouseNote
  const vfsFonts = await import("pdfmake/build/vfs_fonts")

  pdfMake.fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf'
    },
    weiruanyahei: {
      normal: '微软雅黑.ttf',
      bold: '微软雅黑.ttf',
      italics: '微软雅黑.ttf',
      bolditalics: '微软雅黑.ttf'
    }
  }
  const { vfs } = vfsFonts.pdfMake
  pdfMake.vfs = vfs

  const tableWidth = [100, 290, '*', '*', 30]
  const contents = table(data)
  const content2 = tableOutstanding(outstanding)

  const formatDate = (date: string) => {
    if (!date) return ''

    let utcDate = date.replace(' ', 'T')
    if (!utcDate.endsWith('Z')) {
      utcDate = utcDate + 'Z'
    }

    const dateObj = new Date(utcDate)
    const formatter = new Intl.DateTimeFormat('en-NZ', {
      timeZone: 'Pacific/Auckland',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })

    const parts = formatter.formatToParts(dateObj)
    const day = parts.find(p => p.type === 'day')?.value
    const month = parts.find(p => p.type === 'month')?.value
    const year = parts.find(p => p.type === 'year')?.value

    return `${day}/${month}/${year}`
  }

  const getCurDate = () => {
    const da = new Date()
    var year = da.getFullYear()
    var month = da.getMonth() + 1
    var date = da.getDate()
    return date + '/' + month + '/' + year
  }

  const getNumber = (data: any) => {
    let ret
    const mobile = data?.customer?.customer?.mobile
    const phone = data?.customer?.customer?.phone
    if (mobile && !phone)
      ret = mobile
    else if (phone && !mobile)
      ret = phone
    else if (phone && mobile)
      ret = mobile + "," + phone
    else
      ret = ""
    return ret
  }

  const formatAddress = (address: string) => {
    if (!address) return ' '
    return address.replace(/,/g, ',\n')
  }

  const getLine = (data: any) => {
    if (!data || data.length == 0) return "\n\n\n"
    if (data.length <= 160) return data + "\n\n\n"
    if (data.length <= 320) return data + "\n\n"
    return data + "\n"
  }

  const textToBase64Barcode = (text: string) => {
    const canvas = document.createElement('canvas')
    JsBarcode(canvas, text, { displayValue: false })
    return canvas.toDataURL('image/png')
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [15, 40, 30, 130],
    info: {
      title: 'PackingSlip: ' + data.packingSlipNo,
      author: 'Jadcup',
      subject: 'PackingSlip: ' + data.packingSlipNo,
      keywords: 'Jadcup',
    },
    content: [
      {
        fontSize: 10,
        table: {
          headerRows: 1,
          widths: ['*'],
          heights: [80, 100, 50, 20, 80],
          layout: 'noBorders',
          body: [
            // Header Row One
            [
              {
                columns: [
                  {
                    image: logo2Img,
                    width: 96, height: 100,
                    margin: [15, -20, 0, 0]
                  },
                  {
                    columns: [
                      {
                        type: 'none',
                        ul: [
                          { text: 'Packing Slip', alignment: 'center', bold: true, fontSize: 20, color: 'black', margin: [0, 0, 0, 0] },
                          { text: 'No: ' + orderNo, alignment: 'center', fontSize: 12, color: 'black', margin: [0, 5, 0, 0] },
                          { text: deliveredAt ? ('Date:' + formatDate(deliveredAt)) : ('Date: ' + getCurDate()), fontSize: 12, margin: [0, 0, 0, 0], alignment: 'center' },
                        ]
                      },
                      {
                        image: textToBase64Barcode(orderNo),
                        width: 145, height: 60,
                      },
                    ]
                  },
                ]
              }
            ],
            // Second Header Row
            [
              {
                margin: [0, -18, 0, 0],
                columns: [
                  {
                    width: '*',
                    type: 'none',
                    ul: [
                      { text: ' ', fontSize: 12, bold: true },
                      { text: 'Bill To: ', fontSize: 11, bold: true },
                      { text: `${data.customer.customer.company ? data.customer.customer.company : ' '}`, fontSize: 10 },
                      { text: formatAddress(data.customer.customer.address1), alignment: 'left', fontSize: 10 },
                    ]
                  },
                  {
                    width: '*',
                    type: 'none',
                    ul: [
                      { text: 'Purchase Order: ' + (data.customer.custOrderNo || ''), fontSize: 11, bold: true, margin: [0, 0, 0, 0] },
                      {
                        table: {
                          widths: ['*'],
                          body: [
                            [{ text: 'Ship To: ', alignment: 'left', fontSize: 11, bold: true, border: [true, false, true, false], color: "white", lineHeight: 0.8, fillColor: '#12231a' }],
                            [
                              { text: `${deliveryName ? deliveryName : data.customer.customer.customerCode ? data.customer.customer.customerCode : ' '}\n` +
                                `${data.customer.deliveryAddress ? data.customer.deliveryAddress : ' '}`.replace(/,/, '').replace(/,/g, ',\n')
                                , alignment: 'left', fontSize: 10, border: [true, false, true, true] },
                            ]
                          ]
                        }
                      },
                    ]
                  }
                ]
              }
            ],
            [
              {
                margin: [0, -27, 0, 0],
                layout: 'noBorders',
                fontSize: 8,
                table: {
                  widths: ['*'],
                  body: [
                    [
                      {
                        margin: [3, 0, 0, 5],
                        fontSize: 8,
                        fillColor: '#12231a',
                        table: {
                          widths: tableWidth,
                          body: [
                            [
                              { text: 'Item Code', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                              { text: 'Product Description', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                              { text: 'Pack', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                              { text: 'Qty', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                              { text: 'Total', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                            ],
                          ],
                        },
                        layout: 'headerLineOnly',
                      }
                    ],
                    [
                      {
                        margin: [3, 0, 0, 0],
                        fontSize: 8,
                        lineHeight: 1.3,
                        table: {
                          widths: tableWidth,
                          body: [
                            ...contents,
                          ],
                        },
                        layout: 'headerLineOnly',
                      }
                    ]
                  ]
                }
              }
            ],
            [
              content2.length <= 0 ? null : {
                margin: [0, 0, 0, 0],
                style: 'tableExample',
                fontSize: 8,
                lineHeight: 1.3,
                table: {
                  widths: ['*'],
                  body: [
                    [
                      content2.length <= 0 ? null : {
                        margin: [0, 0, 0, 0],
                        columns: [
                          {
                            type: 'none',
                            ul: [
                              { text: "***The following table shows an outstanding item in backorder for this Purchase Order: " + (data.customer.custOrderNo || ''), bold: true, fontSize: 10 },
                            ],
                          }
                        ]
                      }
                    ],
                    [
                      content2.length <= 0 ? null : {
                        margin: [0, 0, 0, 0],
                        style: 'tableExample',
                        fontSize: 8,
                        fillColor: '#12231a',
                        table: {
                          widths: tableWidth,
                          body: [
                            [
                              { text: 'Item Code', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                              { text: 'Product Description', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                              { text: 'Pack', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                              { text: 'Qty', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                              { text: 'Total', bold: true, color: 'white', fontSize: 8, fillColor: '#12231a' },
                            ],
                          ],
                        },
                        layout: 'headerLineOnly',
                      }
                    ],
                    [
                      content2.length <= 0 ? null : {
                        margin: [0, 0, 0, 0],
                        style: 'tableExample',
                        fontSize: 8,
                        lineHeight: 1.5,
                        table: {
                          widths: tableWidth,
                          body: [
                            ...content2,
                          ],
                        },
                        layout: 'headerLineOnly',
                      }
                    ],
                  ],
                  border: [true, true, true, true]
                }
              }
            ],
          ]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 120]
      },
    ],
    defaultStyle: {
      font: 'Roboto',
    },
    footer: function () {
      return [
        {
          margin: [30, -70, 30, -80],
          fontSize: 10,
          columns: [
            {
              table: {
                headerRows: 1,
                widths: ['*'],
                body: [
                  [{ text: 'Please read the following carefully before signing:\n', fontSize: 10, bold: true, border: [false, false, false, false] }],
                  [
                    { text:
                      '* Ensure the product and quantity are correct before signing.\n' +
                      "* You must advise us within 48 hours of any discrepancies or claims.\n" +
                      "* Returns or exchanges are accepted within three days of receipt.\n" +
                      "* Return shipping costs are the responsibility of the customer, unless the return is due to our error.\n" +
                      "* Items must be in their original condition, unused, and with all original packaging.\n"
                      , fontSize: 9, border: [false, false, false, false] }
                  ],
                  [
                    { columns: [
                      { text: 'Customer Signature: _________________________', bold: true, border: [false, false, false, false] },
                      { text: 'Date:_____________________________', bold: true, border: [false, false, false, false] }
                    ], border: [false, false, false, false] }
                  ],
                  [{ text: 'Delivery Method & Instruction: ' + ((data?.courier) ? data.courier : " "), border: [true, true, true, true], bold: true, color: 'white', fillColor: '#12231a', lineHeight: 1.3 }],
                  [{ text: getLine(comments), border: [true, true, true, true], lineHeight: 1.3 }],
                ]
              }
            }
          ]
        },
        {
          margin: [0, 85, 0, 0],
          columns: [
            [
              { text: 'Operation hours: 8:30 am - 5:00 pm, Monday to Friday', alignment: 'center', lineHeight: 1.3, bold: true, fontSize: 9 },
              { text: 'Customer Service: 092823988 / Email: order@jadcup.co.nz / Address: 17b Landing Drive, Mangere, Auckland', alignment: 'center', lineHeight: 1.3, bold: true, fontSize: 8 },
            ]
          ],
        },
      ]
    },
    pageBreakBefore: function (currentNode: any, followingNodesOnPage: any, nodesOnNextPage: any, previousNodesOnPage: any) {
      return currentNode.headlineLevel === 'Conditions' && currentNode.startPosition.top > 720
    },
  }

  if (require === "getBlob") {
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition)
    pdfDocGenerator.getBlob((blob) => {
      console.log(blob, 'blob')
      getBlob(filename, blob)
    })
  }
  else
    pdfMake.createPdf(documentDefinition).open()
}

const table = (data: any) => {
  let mainData = data.tableContent.map((res: any) => {
    return [
      res.product?.replace(/\u2011/g, '-'),
      res.description?.replace(/\u2011/g, '-') + '\n',
      res.quantity,
      res.carton,
      res.sum
    ]
  })
  if (data.palletType)
    mainData.push(["", changePalletName(data.palletType), "", data.palletTypeQty, ""])
  return mainData
}

const changePalletName = (str: any) => {
  let start = str.indexOf("(")
  return str.substr(0, start) + " Pallet"
}

/**
 * 根据箱数判断是否还有 back order
 * 如果订单箱数 > 已送货箱数，则该产品在 back order 中
 */
const tableOutstanding = (data: any) => {
  return data
    .filter((res: any) => {
      const packagingQuantity = res.product.baseProduct.packagingType.quantity;
      // 订单箱数 = 向上取整(订单数量 / 每箱数量)
      const orderBoxes = Math.ceil(res.quantity / packagingQuantity);
      // 已送货箱数 = 向上取整(已送货数量 / 每箱数量)
      const deliveredBoxes = Math.ceil(res.dispatchedQuantity / packagingQuantity);
      // 如果订单箱数 > 已送货箱数，则该产品在 back order 中
      return orderBoxes > deliveredBoxes;
    })
    .map((res: any) => {
      const packagingQuantity = res.product.baseProduct.packagingType.quantity;
      const orderBoxes = Math.ceil(res.quantity / packagingQuantity);
      const deliveredBoxes = Math.ceil(res.dispatchedQuantity / packagingQuantity);
      const remainingBoxes = orderBoxes - deliveredBoxes;
      const remainingQuantity = res.quantity - res.dispatchedQuantity;

      return [
        res.product.productCode?.replace(/\u2011/g, '-'),
        res.product.productName?.replace(/\u2011/g, '-') + '\n',
        packagingQuantity,
        remainingBoxes,
        remainingQuantity
      ]
    })
}
